import {
  DatasetSchema,
  RepoExampleCreateSchema,
  RunSchema,
} from '@/types/schema';

import { createEmptyOutput } from './create-empty-output';

export function convertRunToDatasetExample(
  runId: string,
  dataset: DatasetSchema
): RepoExampleCreateSchema {
  const example = {
    dataset_id: dataset.id,
    source_run_id: runId,
    use_source_run_io: true,
  };
  return example;
}

export function convertRunToDatasetExampleManualIO(
  io: Pick<RunSchema, 'inputs' | 'outputs' | 'extra' | 'id'>,
  dataset: DatasetSchema
): RepoExampleCreateSchema | null {
  const defaultInputs = io.inputs;
  let defaultOutputs: Record<string, any> | null | undefined = io.outputs;
  let example: RepoExampleCreateSchema;
  try {
    //if outputs is empty, set to an empty output so that the backend will still accept it
    if (!defaultOutputs || Object.keys(defaultOutputs).length === 0) {
      defaultOutputs = createEmptyOutput(dataset.data_type);
    }

    example = {
      dataset_id: dataset.id,
      inputs: defaultInputs,
      outputs: defaultOutputs,
      source_run_id: io.id,
    };
    if (typeof defaultInputs !== 'object' || Array.isArray(defaultInputs)) {
      throw new Error('Invalid JSON');
    }
    if (typeof defaultOutputs !== 'object' || Array.isArray(defaultOutputs)) {
      throw new Error('Invalid JSON');
    }
  } catch (e) {
    console.error(e);
    return null;
  }
  return example;
}
